module.exports = __webpack_public_path__ + "9788f41e/img/file-icon.c085e21e.svg";